/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    NotificationListDto,
    NotificationListDtoFromJSON,
    NotificationListDtoToJSON,
    NotificationTypeEnum,
    NotificationTypeEnumFromJSON,
    NotificationTypeEnumToJSON,
} from '../models';

export interface NotificationControllerListRequest {
    type?: NotificationTypeEnum;
    portfolioId?: string;
    readStatus?: NotificationControllerListReadStatusEnum;
    limit?: number;
    offset?: number;
}

export interface NotificationControllerMarkAsReadRequest {
    id: string;
}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI {

    /**
     * Get current user notifications
     */
    async notificationControllerListRaw(requestParameters: NotificationControllerListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<NotificationListDto>> {
        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.portfolioId !== undefined) {
            queryParameters['portfolioId'] = requestParameters.portfolioId;
        }

        if (requestParameters.readStatus !== undefined) {
            queryParameters['readStatus'] = requestParameters.readStatus;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationListDtoFromJSON(jsonValue));
    }

    /**
     * Get current user notifications
     */
    async notificationControllerList(requestParameters: NotificationControllerListRequest = {}, initOverrides?: RequestInit): Promise<NotificationListDto> {
        const response = await this.notificationControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark all current user notifications as read
     */
    async notificationControllerMarkAllAsReadRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/read-all`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark all current user notifications as read
     */
    async notificationControllerMarkAllAsRead(initOverrides?: RequestInit): Promise<void> {
        await this.notificationControllerMarkAllAsReadRaw(initOverrides);
    }

    /**
     * Mark current user notification as read
     */
    async notificationControllerMarkAsReadRaw(requestParameters: NotificationControllerMarkAsReadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling notificationControllerMarkAsRead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/{id}/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark current user notification as read
     */
    async notificationControllerMarkAsRead(requestParameters: NotificationControllerMarkAsReadRequest, initOverrides?: RequestInit): Promise<void> {
        await this.notificationControllerMarkAsReadRaw(requestParameters, initOverrides);
    }

}

/**
    * @export
    * @enum {string}
    */
export enum NotificationControllerListReadStatusEnum {
    Read = 'read',
    Unread = 'unread'
}
